import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Heading, MissedCallIconSmall, Text } from '@frontend/design-system';

/**
 * Shown in workspace mode when the user's locations have phone system access.
 * Displays a "silenced" notice with no Manage button.
 * The parent gate (hasPhoneSystemAccess) already ensures this only renders
 * when the locations have phone access.
 */
export const WorkspaceScopedDeviceSection = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Heading level={2}>{t('Connected Device')}</Heading>
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateAreas: '"icon title" ". message"',
          columnGap: theme.spacing(1),
          alignItems: 'center',
        }}
      >
        <span style={{ color: theme.colors.neutral50, gridArea: 'icon' }}>
          <MissedCallIconSmall />
        </span>
        <Text as='span' css={{ gridArea: 'title' }}>
          {t('Connected Device is silenced in workspace mode.')}
        </Text>
        <Text size='medium' color='light' css={{ gridArea: 'message' }}>
          {t('You are not currently able to place or receive calls within the Weave app.')}
        </Text>
      </div>
    </div>
  );
};
